import { makeAutoObservable, runInAction } from 'mobx'
import { deskMobx } from 'restaurant'
import { StoreAPI } from '@api/index'

class PosServiceMobx {
  constructor () {
    makeAutoObservable(this, {}, {
      autoBind: true
    })
  }

  serviceRingInter: any = null

  serviceRingDuration: number = 0

  async sendServiceRing (content?: string) {
    // !content 代表服务铃操作
    if (!content && this.serviceRingDuration > 0) return
    const storeId = Config.STOREID
    const tableCode = Config.TABLECODE
    const tableAlias = deskMobx.tableCodeToTableAliasMap[tableCode]
    if (!storeId || !tableCode || !tableAlias) return
    const success = await StoreAPI.sendServiceRing({ storeId, tableCode, tableAlias, content })
    this.serviceRingDuration = 60
    if (!content) {
      this.serviceRingInter = setInterval(() => {
        if (this.serviceRingDuration === 0) {
          clearInterval(this.serviceRingInter)
        }
        runInAction(() => {
          this.serviceRingDuration--
        })
      }, 1000)
    } else {
      this.serviceRingInter = null
    }
    return success
  }
}

export default new PosServiceMobx()
